import React, { useEffect } from "react";
import Layout from "./Layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice.js";
import ListCategoriasSection from "../sections/ListCategoriasSection.jsx";

const ListCategorias = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError && !user) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  return (
    <>
      <Layout>
        <ListCategoriasSection />
      </Layout>
    </>
  );
};

export default ListCategorias;
